import {
  getProductWithCategory,
  getProductWithTag,
  getUniqueCategories,
  getUniqueTags,
} from "../../helpers/product";
import React from "react";
import { setActiveSort } from "../../helpers/product";

const ShopProductTag = ({
  products,
  getSortParams,
  sideSpaceClass,
  value,
  setSortValues,
}) => {
  const uniqueTags = getUniqueTags(products)?.sort();

  return (
    <div className="row g-4">
      {uniqueTags?.map((tag) => {
        if (tag === "") return null;
        const numArt = getProductWithTag(products, tag);
        return (
          <div
            className="col-12 col-md-2"
            key={tag}
            onClick={(e) => {
              //document.querySelector("#allTags").classList.remove("active");
              if (e.currentTarget.classList.contains("active"))
                getSortParams("tag", tag, "-");
              else getSortParams("tag", tag, "+");
              setActiveSort(e);
            }}
            
          >
            <div className="card text-center shadow-sm border-0" style={{height:"200px"}}>
              <div className="card-body" 
              style={{
                backgroundImage: 
    "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('"+global.baseUrlImage + "tag/" + tag + ".png"+"')", backgroundSize: "cover", backgroundPosition: "center",
  
                alignItems:"center",
                justifyContent:"center",
                display: "flex", flexDirection: "column"
              }}>
                {/*<div className="p-3 bg-white text-white rounded-circle d-inline-block mb-3 border border-primary border-5">*/}
                  {/*<img
                    src={global.baseUrlImage + "tag/" + tag + ".png"}
                    width="100"
                    height="100"
                  />*/}
                {/*</div>*/}
                <h3 className="card-title" style={{color:"white"}}>{tag}</h3>
                <h5 className="card-text " style={{color:"white"}}>{numArt} prodotti</h5>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShopProductTag;
